// Po pełną dokumentację API wraz z przykładami kodu, odwiedź http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function horizontalMenu1_viewportEnter(event, $w) {
	//Add your code for this event here: 
}